import React from 'react';
import { CONSTANTES } from '../../config/constantaes';

const LandingBackground = ({ children }) => (
  <div
    className="col-md-6 d-flex flex-column align-items-center mb-2 mb-md-0 custom-background movil-contenedor"
    style={{
      position: 'relative',
      backgroundImage: `url(${CONSTANTES.LANDING_BACKGROUND_IMAGE})`
    }}
  >
    {children}
  </div>
);

export default LandingBackground;
